import { BaseModal } from 'components/modals/BaseModal';
import React from 'react';
import styled from 'styled-components';
import { AddContentToCourse } from './shared/AddContentToCourse';

interface IProps {
  contentItem: any;
  onClose: () => void;
}

export const AddToCourseModal = (props: IProps) => {
  const { contentItem, onClose } = props;

  return (
    <BaseModal title={`Add "${contentItem.name}" to Course`} onClose={onClose}>
      <ModalContent>
        <AddContentToCourse contentItem={contentItem} />
      </ModalContent>
    </BaseModal>
  );
};

const ModalContent = styled.div`
  width: 80vw;
  height: 80vh;
  display: flex;
  flex-direction: column;
`;
